import { gql } from "@apollo/client";
import { FRAGMENT_SECTIONS } from "../../graphql/section.fragment";

export const groupSection = gql`
  query groupSection(
    $scenarioId: ID!
    $originId: ID!
    $resourceType: ResourceType!
    $resourceId: ID!
  ) {
    base {
      customFields(resourceType: $resourceType) {
        id
        code
        name
        label
      }
    }
    cube(scenarioId: $scenarioId, originId: $originId) {
      editorView(resourceType: $resourceType, resourceId: $resourceId) {
        info {
          __typename
          ... on GroupInfo {
            group {
              id
              code
              label
              name
              capacity
              type
              text
              references {
                id
                value
                referenceCategoryId
                enabled
                meta
                referenceCategory {
                  id
                  code
                  name
                }
                __typename
              }
              clientCode
              visibleForEnrollment
              subject {
                id
                enrollmentRestrictions {
                  table
                  operator
                  attribute
                  valueIds
                  values {
                    ... on CustomModelValue {
                      id
                      customModelValueCode: code
                      customModelValueValue: value
                      customModelValueLabel: label
                      __typename
                    }
                    ... on Modality {
                      id
                      modalityCode: code
                      modalityName: name
                      __typename
                    }
                    ... on Campus {
                      id
                      campusCode: code
                      campusName: name
                      __typename
                    }
                    ... on Program {
                      id
                      programCode: code
                      programName: name
                      __typename
                    }
                    ... on Curriculum {
                      id
                      curriculumCode: code
                      curriculumName: name
                      __typename
                    }
                  }
                }
              }
              groupEnrollmentRestrictions {
                table
                operator
                attribute
                valueIds
                values {
                  ... on CustomModelValue {
                    id
                    customModelValueCode: code
                    customModelValueValue: value
                    customModelValueLabel: label
                    __typename
                  }
                  ... on Modality {
                    id
                    modalityCode: code
                    modalityName: name
                    __typename
                  }
                  ... on Campus {
                    id
                    campusCode: code
                    campusName: name
                    __typename
                  }
                  ... on Program {
                    id
                    programCode: code
                    programName: name
                    __typename
                  }
                  ... on Curriculum {
                    id
                    curriculumCode: code
                    curriculumName: name
                    __typename
                  }
                }
                __typename
              }
              term {
                code
                id
                name
                start_date
                end_date
              }
              course {
                code
                name
                tags
                courseType
                corequisiteKeys
                curriculum {
                  id
                  name
                  program {
                    id
                    code
                    campus {
                      id
                      code
                      name
                      __typename
                    }
                    modality {
                      id
                      code
                    }
                  }
                }
              }
              customFields {
                id
                value
                code
              }
              links {
                id
                vacancies
                code
                bundle {
                  id
                  code
                  label
                  name
                  capacity
                }
              }
              enrollmentStats {
                id
                enrollmentsCount
                waitingListsCount
              }
              labels {
                id
                code
                name
                category {
                  id
                  code
                  name
                  labelSource {
                    id
                    code
                    name
                  }
                }
              }
              totalBlocks
              totalBlocksWithInstructors
            }
            __typename
          }
        }
        ...CalendarSections
      }
      editorWeeks(resourceType: $resourceType, resourceId: $resourceId) {
        id
        name
        startingDate
        endingDate
        eventCount
        termParts {
          id
          code
          name
          category {
            id
            code
            name
          }
        }
      }
    }
  }
  ${FRAGMENT_SECTIONS}
`;

export const groupSectionShort = gql`
  query groupSectionShort(
    $scenarioId: ID!
    $originId: ID!
    $resourceType: ResourceType!
    $resourceId: ID!
  ) {
    cube(scenarioId: $scenarioId, originId: $originId) {
      editorView(resourceType: $resourceType, resourceId: $resourceId) {
        info {
          __typename
          ... on GroupInfo {
            group {
              id
              code
              label
              name
              capacity
              type
              text
              clientCode
              visibleForEnrollment
              subject {
                id
                enrollmentRestrictions {
                  table
                  operator
                  attribute
                  valueIds
                  values {
                    ... on CustomModelValue {
                      id
                      customModelValueCode: code
                      customModelValueValue: value
                      customModelValueLabel: label
                      __typename
                    }
                    ... on Modality {
                      id
                      modalityCode: code
                      modalityName: name
                      __typename
                    }
                    ... on Campus {
                      id
                      campusCode: code
                      campusName: name
                      __typename
                    }
                    ... on Program {
                      id
                      programCode: code
                      programName: name
                      __typename
                    }
                    ... on Curriculum {
                      id
                      curriculumCode: code
                      curriculumName: name
                      __typename
                    }
                  }
                }
              }
              groupEnrollmentRestrictions {
                table
                operator
                attribute
                valueIds
                values {
                  ... on CustomModelValue {
                    id
                    customModelValueCode: code
                    customModelValueValue: value
                    customModelValueLabel: label
                    __typename
                  }
                  ... on Modality {
                    id
                    modalityCode: code
                    modalityName: name
                    __typename
                  }
                  ... on Campus {
                    id
                    campusCode: code
                    campusName: name
                    __typename
                  }
                  ... on Program {
                    id
                    programCode: code
                    programName: name
                    __typename
                  }
                  ... on Curriculum {
                    id
                    curriculumCode: code
                    curriculumName: name
                    __typename
                  }
                }
                __typename
              }
              term {
                code
                id
                name
                start_date
                end_date
              }
            }
            __typename
          }
        }
      }
    }
  }
`;
